import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { BatchSpanProcessor } from '@opentelemetry/tracing';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import { Resource } from '@opentelemetry/resources';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { W3CTraceContextPropagator } from '@opentelemetry/core';

const provider = new WebTracerProvider({
  resource: new Resource({
    'service.name': 'hxManager',
  }),
});

const exporter = new OTLPTraceExporter({
  url: 'https://api.honeycomb.io/v1/traces',
  headers: {
    'x-honeycomb-team': window.env.REACT_APP_HONEYCOMB_API_KEY,
  },
});

provider.addSpanProcessor(new BatchSpanProcessor(exporter));

provider.register({
  contextManager: new ZoneContextManager(),
  propagator: new W3CTraceContextPropagator(), // propogates traces from frontend to backend
});

const corsUrls = [window.env.REACT_APP_INTAKE_ENDPOINT, window.env.REACT_APP_CUSTOMER_ENDPOINT];
// Convert into a regex that matches URLs starting with those strings (escapes special characters)
const regexCorsUrls = corsUrls.map((url) => new RegExp(`^${url.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`));

registerInstrumentations({
  instrumentations: [
    new XMLHttpRequestInstrumentation({
      propagateTraceHeaderCorsUrls: regexCorsUrls,
    }),
  ],
});
